import toPairs from 'lodash/toPairs'
import arrayWrap from '@/utils/arrayWrap'

export default function (resources, schema) {
    toPairs(resources).forEach(([type, modelsById]) => {
        toPairs(modelsById).forEach(([id, model]) => {
            const resource = resources[type][id]
            const relations = schema[type] && schema[type].relations || []

            applyRelations(resource, relations)
        })
    })
}

function applyRelations(resource, relations) {
    toPairs(relations).forEach(([relationName, { inverse }]) => {
        if (inverse && resource[relationName]) {
            setRelation(resource[relationName], inverse, resource)
        }
    })
}

function setRelation(models, relationName, value) {
    const filtered = models.filter(x => x != null);
    arrayWrap(filtered).forEach(model => {
        if (!model.hasOwnProperty(relationName)) {
            model[relationName] = value
        }
    })
}
